import type { AiModelRecord } from "../models/types.js";
import { ModelNameResolver } from "./modelNameResolver/ModelNameResolver.js";
import type {
  ModelResolutionInput,
  ModelResolutionResult,
  ModelResolutionSuccess,
  ModelResolverOptions,
  ResolvedModel,
} from "./modelNameResolver/types.js";

export { ModelNameResolver } from "./modelNameResolver/ModelNameResolver.js";
export { buildCatalogIndexes } from "./modelNameResolver/catalogIndexes.js";
export * from "./modelNameResolver/types.js";
export {
  loadOpenRouterRoutingEnv,
  shouldDefaultRouteViaOpenRouter,
  isEffectiveOpenRouterTransport,
  providerIdToEnvKeyPrefix,
  vendorApiKeyEnvName,
} from "./openRouterRoutingEnv.js";
export type { OpenRouterRoutingConfig } from "./openRouterRoutingEnv.js";
export { normalizeString, normalizeProvider } from "./modelNameResolver/normalize.js";
export {
  resolveModelVendorSync,
  resolveModelVendorFromResolution,
  resolveModelVendorLastResort,
  modelVendorRefFromIdentity,
  modelVendorRefFromVendorAndSlug,
} from "./modelNameResolver/resolveModelVendor.js";
export type {
  ModelVendorRef,
  ResolveModelVendorOptions,
} from "./modelNameResolver/resolveModelVendor.js";

export function createModelNameResolver(
  catalog: Map<string, AiModelRecord>,
  options?: ModelResolverOptions,
): ModelNameResolver {
  return new ModelNameResolver(catalog, options);
}

/** Resolve a model string; returns catalog record only (no resolution metadata). */
export function resolveModel(
  input: string,
  models: Map<string, AiModelRecord>,
  provider?: string,
): ResolvedModel | null {
  const resolver = new ModelNameResolver(models);
  const result = resolver.resolve({ model: input, provider });
  if (!result.found || !result.record) return null;
  return {
    catalogModel: result.record,
    matchedKey: result.modelId,
    routedViaOpenRouter: result.routedViaOpenRouter,
  };
}

export function isRoutedViaOpenRouter(
  provider: string | undefined,
  model: AiModelRecord,
  matchedKey: string,
): boolean {
  if (provider === "openrouter") return true;
  if (provider && provider !== "openrouter") return false;
  return model.modelId.includes("/") && matchedKey.includes("/");
}

export type {
  ModelResolutionInput,
  ModelResolutionResult,
  ModelResolutionSuccess,
  ModelResolverOptions,
};
